import { isProduction } from "core/env";

export const init = () => {
  if (isProduction())
    window.Intercom("boot", {
      app_id: "s3az48i5"
    });
};

export const update = () => {
  if (isProduction()) window.Intercom("update");
};

export function setUser(id, email, name) {
  if (isProduction())
    window.intercomSettings = {
      app_id: "s3az48i5",
      user_id: id,
      email,
      ...(name && { name })
    };
}

export function track(eventName, metadata) {
  if (isProduction()) window.Intercom("trackEvent", eventName, metadata);
}



// WEBPACK FOOTER //
// ./src/core/integrations/intercom/index.js